import { render, staticRenderFns } from "./calling.vue?vue&type=template&id=73b9ba2b&scoped=true&"
import script from "./calling.vue?vue&type=script&lang=js&"
export * from "./calling.vue?vue&type=script&lang=js&"
import style0 from "./calling.vue?vue&type=style&index=0&id=73b9ba2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9ba2b",
  null
  
)

export default component.exports